import { Component, OnDestroy, OnInit, ChangeDetectorRef } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { MediaMatcher } from "@angular/cdk/layout";
import { trigger, state, style, transition, animate } from "@angular/animations";
import { MapHelperService } from "../../../../../../../../../services/map-helper.service";
import { IRouteDetails } from "../../../../models/IRouteDetails";
import { IRouteDetailsAnt } from "../../../../models/IRouteDetailsAnt";
import { IRouteMapRequest } from "../../../../models/IRouteMapRequest";
import { PanelResumeRouteService } from "../../../../services/Panel-Resume-Route.service";
import { MatLegacyTabChangeEvent as MatTabChangeEvent } from "@angular/material/legacy-tabs";
import { ResumeRouteMapDTO } from "../../../../models/ResumeRouteMapDTO";
import { RouteMapService } from "../../../../services/RouteMap.service";
import { RouteFilterService } from "../../../../services/Route-Filter.service";
import { TutorialService } from "src/app/features/ui/organisms/tutorial/services/tutorial.service";
import { SessionService } from "src/app/features/shared/services/Session.service";
import { environment } from "src/environments/environment";
import { LocalStorageService } from "src/app/features/shared/services/LocalStorage.service";

@Component({
  selector: "panel-resume-route",
  templateUrl: "./panel-resume-route.component.html",
  styleUrls: ["./panel-resume-route.component.css"],
  animations: [
    trigger("mostrarHerramientas", [
      state("visible", style({ opacity: 1, height: "*", minHeight: "*" })),
      state("hidden", style({ opacity: 0, height: "0px", minHeight: "0", overflow: "hidden", display: "none" })),
      transition("visible <=> hidden", animate("200ms ease-in-out")),
    ]),
  ],
})
export class PanelResumeRouteComponent implements OnInit, OnDestroy {
  public Id: string;
  private $Id: Observable<string> = new Observable<string>();
  private $Data: Observable<IRouteDetails> = new Observable<IRouteDetails>();
  isLoading: boolean = false;
  Data: ResumeRouteMapDTO = {
    StartDate: "",
    EndDate: "",
    Distance: "",
    DurationTime: "",
    VelocityProm: "",
    cantStops: "",
    Identifier: "",
    Description: "",
    sGeojsonResume: "",
    idLocationCategory: ""
  };

  Data2: IRouteDetailsAnt = {
    id: "",
    startTime: "",
    endTime: "",
    distance: "",
    description: "",
    durationTime: "",
    velocityProm: "",
    cantNodes: "",
    createdBy: "",
    createdIn: "",
    startLocation: "",
    endLocation: "",
    location: null
  };
  Repetido: number[] = [1,2,3,4,5];
  Title: string;
  $isVisible: Observable<boolean> = new Observable<boolean>();
  isVisible: boolean;
  request: IRouteMapRequest;
  roles: any;
  isAdmin: boolean;
  dates: string[];
  emptyDates: boolean;
  selectedTabIndex: number;
  public isMapix: boolean = false;
  subscription_RecuperateResume: Subscription;
  identifier: string;
  panelIcon: string = "";
  fullScreen: boolean = false;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  isToolButtonPressed: boolean = false;

  subscription_CheckData: Subscription;
  Suscription_GetRequest: Subscription;
  Suscription_GetResume: Subscription;
  subscription_isVisible: Subscription;

  constructor(
    private panelResumeService: PanelResumeRouteService,
    private routeMapService: RouteMapService,
    private mapHelperService: MapHelperService,
    private sessionService: SessionService,
    private routeMapFilterService: RouteFilterService,
    private tutorialService: TutorialService,
    private localStorageService: LocalStorageService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 769px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.subscription_CheckData = this.panelResumeService.getResume().subscribe({
      next: (data) => {
        if(!environment.production) console.log("ACTUALIZANDO DATA");
        if(!environment.production) console.log(data);
        this.Data = data;
        this.panelIcon = this.getPanelIcon(this.Data.idLocationCategory);
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener ruta (resume)', error);
      }
    });

    this.Suscription_GetRequest = this.panelResumeService.getRequest().subscribe({
      next: (data) => {
        this.request = data;
        let date1 = new Date(this.request.StartDate);
        date1.setHours(date1.getHours() - 6);
        let date2 = new Date(this.request.EndDate);
        date2.setHours(date2.getHours() - 6);
        this.dates= [date1.toISOString(),date2.toISOString()];
        this.identifier = this.request.Identifier;
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener ruta (request)', error);
      }
    });

    this.$isVisible = this.panelResumeService.checkVisibilityPopup();
    this.subscription_isVisible = this.$isVisible.subscribe((element) => {
      this.isVisible = element;
      if (this.isVisible) {
        this.routeMapFilterService.setVisibilityPanel(false);
      }
      setTimeout(() => {
        if (this.isVisible != undefined && this.isVisible == true) {
          this.tutorialService.startTutorial(["panelRouteResumeTutorial"]);
        }
      }, 1000);
    });

    
      if(this.sessionService.Customer == undefined || this.sessionService.Customer == null)
        this.sessionService.getCustomerId();

  }

  ngOnInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.checkURLSource();
  }

  ngOnDestroy() {
    if (this.subscription_CheckData)
      this.subscription_CheckData.unsubscribe();
    if(this.Suscription_GetRequest)
      this.Suscription_GetRequest.unsubscribe();
    if(this.Suscription_GetResume)
      this.Suscription_GetResume.unsubscribe();
    if (this.subscription_isVisible)
      this.subscription_isVisible.unsubscribe();

    this.routeMapService.deleteRoutesData();
  }

  selectTab(event: MatTabChangeEvent) {  
    if (event.index == 0) {
      this.selectedTabIndex = 0;
       this.SetMapInitialRoute();
    }else if (event.index == 1){
      this.selectedTabIndex = 1;
      // this.getLocationsDesactualizados();
    }else{
      this.selectedTabIndex = 2;
      // this.getLocationsSinReporte();
    }
  }
  SetMapInitialRoute() {
    // this.mapHelperService.SetBounds(JSON.parse(groupStep[0].sGroupStepGeojson));
    this.mapHelperService.ShowLayer("routeResume-line-layer");
    this.mapHelperService.HideLayer("routeResume-lineOpacityMin-layer");
    this.mapHelperService.UpdateLayerGeoJson("routeGroupStep",this.mapHelperService.Empty_GeoJson);
    this.mapHelperService.SetBounds(JSON.parse(this.Data.sGeojsonResume));
  }
  
  onClosePopup() {
    this.panelResumeService.setVisibilityPopup(false);
  }

  getKeyValue(Key){
    // return this.Data.location.data.value
  }

  onClickReturn() {
    this.routeMapFilterService.setVisibilityPanel(true);
    this.panelResumeService.setVisibilityPopup(false);
    this.routeMapService.deleteRoutesData();
  }

  checkURLSource() {
    this.sessionService.CheckURLSource();
    this.isMapix = this.sessionService.isMapix;
  }
  
  // onFlyToStartLocation(){
  //  var coords = this.Data.startLocation.split(',');
  //  if(!environment.production) console.log(coords);
  //   this.mapHelperService.FlyToCamera(coords[1],coords[0],"20");
  // }

  // onFlyToEndLocation(){
  //   var coords = this.Data.endLocation.split(',');
  //   if(!environment.production) console.log(coords);
  //    this.mapHelperService.FlyToCamera(coords[1],coords[0],"20");
  //  }

  onClickDetailLocation() {
    // this.panelDetailLocationsService.setVisibilityPopup(true);
    // this.panelDetailLocationsService.setTitle(this.Data.identifier);
    // this.panelDetailLocationsService.setSubaccount(this.Data.location.subGroup.name);
    // this.panelDetailLocationsService.setData(this.Data.location.data);
    // this.panelDetailLocationsService.setTime(this.request.StartDate,this.request.EndDate);
    // this.panelDetailLocationsService.setLastUpdate(
    //   this.Data.location.createdIn
    // );
  }

  getPanelIcon(idLocationCategory: string): string {
    const categories = this.localStorageService.getListaCategorias();
    const listaCategorias = categories ? JSON.parse(categories) : [];
    const categoria = listaCategorias.find(cat => cat.id == idLocationCategory);

    return categoria ? categoria.icon : "carA.png";
  }

  onDetailsClicked(event: boolean) {
    if(event)
      this.fullScreen = false;
  }
 
}
